import React from "react";
import { inject, observer } from "mobx-react";

import { Grid } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import AddGroupPermission from "./AddPermissionGroup/AddPermissionGroup";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import TableSearchInput from "@src/Components/Common/TableSearchInput/TableSearchInput";
import { observable, computed } from "mobx";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import PermissionGroupsTable from "./PGTable/PGTable";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { Values } from "@src/Tools/Values";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  auth?: IAuthStore;
  management?: IManagementStore;
}

@inject("auth", "management")
@observer
class PermissionGroupsContent extends React.Component<IProps> {
  @observable searchText: string = "";

  @computed get filteredPermissionGroups() {
    return filterByTableColumns<PermissionGroup>(
      this.props.management.permissionGroups,
      this.searchText
    );
  }

  handleChange = (event: any) => {
    this.searchText = event.target.value;
  };

  render() {
    return (
      <Grid container direction="column">
        <STPageHeader>
          {Values.getLocalizationValue("permissionGroups")}
        </STPageHeader>
        <Grid container justify="space-between" alignItems="center" item>
          <Grid item>
            <TableSearchInput
              value={this.searchText}
              onChange={this.handleChange}
            />
          </Grid>
          {this.props.auth.user.location.primary && (
            <AddGroupPermission />
          )}
        </Grid>
        <Grid item xs>
          {this.filteredPermissionGroups.length > 0 ? (
            <PermissionGroupsTable
              permissionGroups={this.filteredPermissionGroups}
            />
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default PermissionGroupsContent;
